import {Button} from "react-bootstrap";
import {useCookie} from "./Cookie";
import {Link} from "react-router-dom";

export function CookieBanner() {
    const {cookieConsent, toggleCookieConsent} = useCookie()

    return (
        <div>
            {!cookieConsent ? (
                // <div className="d-flex justify-content-center position-fixed bottom-0 w-100" style={{ zIndex: 1050 }}>
                    <div className="d-flex flex-wrap align-items-center justify-content-center p-2 bg-primary-subtle position-fixed bottom-0 w-100" style={{ zIndex: 1050 }}>
                        This website uses cookies to ensure you get the best experience on our website.
                        {/*<Link to="/static/privacy" className="ms-2">Privacy Policy</Link>*/}
                        <Link to="/git/SiteInfo/PrivacyPolicy.md" className="ms-2">Privacy Policy</Link>
                        <Button variant="success" onClick={toggleCookieConsent} className="ms-2" size="sm">Accept</Button>
                    </div>
                // </div>
            ) : (
                <p>You have accepted cookies!</p>
            )}
        </div>
    )
}